import { ToastAlertTypes } from '@genial/components';
import { ColorTypes } from '@genial/design-tokens';
import { IconographyTypes } from '@genial/icons';

export const fixedFeeScreenName = 'fixedFee';

export const cancelPendingSuccessMessage: [ToastAlertTypes.Type, string, string] = [
  'success',
  'Cancelamento realizado com sucesso.',
  'O cancelamento do termo foi realizado com sucesso.',
];

export const cancelActiveSuccessMessage: [ToastAlertTypes.Type, string, string] = [
  'success',
  'Pedido do cancelamento realizado com sucesso.',
  'O pedido do cancelamento do termo foi realizado com sucesso.',
];

export const defaultErrorMessage: [ToastAlertTypes.Type, string, string] = [
  'error',
  'Erro ao enviar solicitação',
  'Não foi possível realizar esta solicitação, tente novamente mais tarde.',
];

export const defaultNotificationResendMessage: [ToastAlertTypes.Type, string, string] = [
  'success',
  'Notificação reenviada com sucesso',
  'A notificação do termo foi reenviada com sucesso.',
];

type FixedFeeStatusIcon = {
  icon: IconographyTypes.Option;
  color: ColorTypes.Option;
  description?: string;
};

type FixedFeeStatusIcons = {
  list: Record<number, FixedFeeStatusIcon>;
  notification: Record<number, FixedFeeStatusIcon>;
};

export enum FixedFeeListStatus {
  Pending = 1,
  Accepted = 2,
  Refused = 3,
  Active = 4,
  Terminating = 5,
  Closed = 6,
  Expired = 7,
  Canceled = 8,
}

export enum FixedFeeNotificationStatus {
  Unknown = 0,
  PendingNotification = 1,
  PendingAcceptance = 2,
  Accepted = 3,
  PendingTerminaceNotification = 4,
  PendingTerminaceAcceptance = 5,
  TerminaceAccepted = 6,
  Canceled = 7,
  CanceledByCustomer = 8,
  Expired = 9,
  Error = 10,
}

export const statusAbleToResendNotification = [FixedFeeListStatus.Pending];
export const statusAbleToCancel = [FixedFeeListStatus.Pending, FixedFeeListStatus.Active];
export const statusAbleToReplace = [FixedFeeListStatus.Active];
export const statusTermBeingRevoked = [
  FixedFeeNotificationStatus.PendingTerminaceNotification,
  FixedFeeNotificationStatus.PendingTerminaceAcceptance,
  FixedFeeNotificationStatus.TerminaceAccepted,
];

export const fixedFeeStatusIcons: FixedFeeStatusIcons = {
  list: {
    0: {
      icon: 'NotFound',
      color: 'scale.base.500',
      description: 'Desconhecido',
    },
    [FixedFeeListStatus.Pending]: {
      icon: 'Clock',
      color: 'scale.orange.900',
      description: 'Pendente',
    },
    [FixedFeeListStatus.Accepted]: {
      icon: 'CheckSpecial',
      color: 'scale.secondary.700',
      description: 'Aceito',
    },
    [FixedFeeListStatus.Refused]: {
      icon: 'CloseCircle',
      color: 'scale.orange.700',
      description: 'Recusado',
    },
    [FixedFeeListStatus.Active]: {
      icon: 'CheckCircle',
      color: 'scale.green.700',
      description: 'Ativo',
    },
    [FixedFeeListStatus.Terminating]: {
      icon: 'Hourglass',
      color: 'scale.orange.700',
      description: 'Em Rescisão',
    },
    [FixedFeeListStatus.Closed]: {
      icon: 'MinusCircle',
      color: 'scale.base.400',
      description: 'Encerrado',
    },
    [FixedFeeListStatus.Expired]: {
      icon: 'Clock',
      color: 'scale.base.400',
      description: 'Expirado',
    },
    [FixedFeeListStatus.Canceled]: {
      icon: 'CloseStatus',
      color: 'feedback.error.default',
      description: 'Cancelado',
    },
  },
  notification: {
    [FixedFeeNotificationStatus.Unknown]: {
      icon: 'NotFound',
      color: 'scale.base.500',
      description: 'Desconhecido',
    },
    [FixedFeeNotificationStatus.PendingNotification]: {
      icon: 'Clock',
      color: 'scale.orange.900',
      description: 'Notificação pendente',
    },
    [FixedFeeNotificationStatus.PendingAcceptance]: {
      icon: 'Clock',
      color: 'scale.orange.900',
      description: 'Pendente de aceite',
    },
    [FixedFeeNotificationStatus.Accepted]: {
      icon: 'CheckSpecial',
      color: 'scale.secondary.700',
      description: 'Aceito',
    },
    [FixedFeeNotificationStatus.PendingTerminaceNotification]: {
      icon: 'Clock',
      color: 'scale.orange.900',
      description: 'Notificação pendente',
    },
    [FixedFeeNotificationStatus.PendingTerminaceAcceptance]: {
      icon: 'Clock',
      color: 'scale.orange.900',
      description: 'Pendente de aceite',
    },
    [FixedFeeNotificationStatus.TerminaceAccepted]: {
      icon: 'CheckSpecial',
      color: 'scale.secondary.700',
      description: 'Aceito',
    },
    [FixedFeeNotificationStatus.Canceled]: {
      icon: 'CloseStatus',
      color: 'feedback.error.default',
      description: 'Cancelado',
    },
    [FixedFeeNotificationStatus.CanceledByCustomer]: {
      icon: 'CloseStatus',
      color: 'feedback.error.default',
      description: 'Cancelado',
    },
    [FixedFeeNotificationStatus.Expired]: {
      icon: 'Clock',
      color: 'scale.base.400',
      description: 'Notificação expirada',
    },
    [FixedFeeNotificationStatus.Error]: {
      icon: 'WarningComplete',
      color: 'feedback.error.default',
      description: 'Erro',
    },
  },
};
